import React, { useState } from "react";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Home from "./pages/Home";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header"; // Make sure to import the Header component

const darkThemeOptions = {
  palette: {
    type: "dark",
    primary: {
      main: "#8601af",
    },
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0b0b0",
    },
  },
};

const lightThemeOptions = {
  palette: {
    primary: {
      main: "#8601af",
    },
  },
};

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const theme = createMuiTheme(
    isDarkMode ? darkThemeOptions : lightThemeOptions
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Header isDarkMode={isDarkMode} toggleDarkMode={setIsDarkMode} />
        <Container>
          <Home />
          <Footer />
        </Container>
      </div>
    </ThemeProvider>
  );
}

export default App;
